import { configureStore } from "@reduxjs/toolkit";
import {
  TypedUseSelectorHook,
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from "react-redux";

import { socketListener } from "./listeners/socketListeners";
import battingPractice from "./slices/battingPractice";
import bullpen from "./slices/bullpen";
import game from "./slices/game";
import hotkeys from "./slices/hotkeys";
import session from "./slices/session";
import settings from "./slices/settings";
import socket from "./slices/socket";
import tiles from "./slices/tiles";
import view from "./slices/view";
import { loadLocalStorage, saveToLocalStorage } from "./storeUtils";

export const createTaggingStore = () => {
  const store = configureStore({
    reducer: {
      // @ts-expect-error - Redux Toolkit type inference limitation with combineReducers
      battingPractice,
      bullpen,
      session,
      socket,
      game,
      view,
      settings,
      hotkeys,
      tiles,
    },
    middleware: (getDefaultMiddleware) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getDefaultMiddleware().prepend(socketListener.middleware) as any,
    preloadedState: loadLocalStorage(),
  });

  store.subscribe(() => {
    const state = store.getState();
    // Don't persist view and socket state - they're session-specific
    const { view: _view, socket: _socket, ...stateToPersist } = state;

    saveToLocalStorage(stateToPersist);
  });

  return store;
};

export type TaggingStore = ReturnType<typeof createTaggingStore>;
export type RootState = ReturnType<TaggingStore["getState"]>;
export type AppDispatch = TaggingStore["dispatch"];

export const useTaggingDispatch = () => useAppDispatch<AppDispatch>();
export const useTaggingSelector: TypedUseSelectorHook<RootState> =
  useAppSelector;
